import { tokens, statLine, statLineBar } from './stats.style.js';
import { jsx, Fragment, jsxs } from 'react/jsx-runtime';

function Stats(props) {
  // calculate the percentage of correct answers for the statistics line
  const correctPercentage = (() => {
    if (!props.score || props.score.pointsPossible === 0) {
      return 0;
    }
    return Math.floor(props.score.pointsGotten / props.score.pointsPossible * 100);
  })();

  // dont show the vertical black bar if the percentage is 0 or 100
  const showStatLineBar = correctPercentage !== 0 && correctPercentage !== 100;
  return /*#__PURE__*/jsx(Fragment, {
    children: props.score && /*#__PURE__*/jsxs(Fragment, {
      children: [/*#__PURE__*/jsxs("span", {
        children: [props.score?.pointsGotten, " ud af ", props.score?.pointsPossible]
      }), /*#__PURE__*/jsx("div", {
        style: tokens.__override({
          correctPercentage: `${correctPercentage}%`
        }),
        className: statLine,
        children: showStatLineBar && /*#__PURE__*/jsx("div", {
          className: statLineBar
        })
      })]
    })
  });
}

export { Stats };
//# sourceMappingURL=stats.js.map
